import request from '@/utils/request'

const api = {
  Query (data) {
    return request({
      url: '/home/task/query',
      method: 'post',
      data
    })
  },
  Delete (data) {
    return request({
      url: '/home/task/delete',
      method: 'post',
      data
    })
  },
  submitForm (data) {
    return request({
      url: '/home/task/createOrUpdate',
      method: 'post',
      data
    })
  },
  fetchArticle (id) {
    return request({
      url: '/home/task/get',
      method: 'post',
      params: { id }
    })
  },
  taskmsg (data) {
    return request({
      url: '/home/task/taskmsg',
      method: 'post',
      data
    })
  },
  getoxen_horses (data) {
    return request({
      url: '/home/task/getoxen_horses',
      method: 'post',
      data
    })
  },
  getoxen_taskmsg (data) {
    return request({
      url: '/home/task/getoxen_taskmsg',
      method: 'post',
      data
    })
  },
  delete_taskmsg (data) {
    return request({
      url: '/home/task/delete_taskmsg',
      method: 'post',
      data
    })
  },
  changeState (data) {
    return request({
      url: '/home/task/changeState',
      method: 'post',
      data
    })
  },
  pctasklist (data) {
    return request({
      url: '/home/task/pctasklist',
      method: 'post',
      data
    })
  },
  uploadFile (data) {
    return request({
      url: '/home/task/uploadFile',
      method: 'post',
      data
    })
  },
  taskMsgList (data) {
    return request({
      url: '/home/task/taskMsgList',
      method: 'post',
      data
    })
  },
  subUploadFiel (data) {
    return request({
      url: '/home/task/subUploadFiel',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/task.js